export default __webpack_public_path__ + "static/media/volkswagen.077bcc20.png";